import { render, staticRenderFns } from "./looding.vue?vue&type=template&id=ce24ec10&"
import script from "./looding.vue?vue&type=script&lang=js&"
export * from "./looding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports